import script from "./GameCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./GameCounter.vue?vue&type=script&setup=true&lang=js"

import "./GameCounter.vue?vue&type=style&index=0&id=2eaccb88&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eaccb88"]])

export default __exports__